import React from 'react';
import { useTranslation } from '../../useTranslation';
import { normalizeUiLanguage } from '../../hooks/useAppLanguage';

interface LanguageSwitcherProps {
  language: string;
  onChange: (language: string) => void;
  className?: string;
  compact?: boolean;
}

/** RU / EN toggle for auth screens. */
export const LanguageSwitcher: React.FC<LanguageSwitcherProps> = ({
  language,
  onChange,
  className = '',
  compact = false,
}) => {
  const { t } = useTranslation(language);
  const current = normalizeUiLanguage(language);

  const btnClass = (active: boolean) =>
    `px-2.5 py-1 text-xs sm:text-sm font-semibold rounded-lg transition-colors ${
      active
        ? 'bg-blue-600 text-white shadow-sm'
        : 'text-stone-600 dark:text-slate-300 hover:bg-stone-100 dark:hover:bg-slate-700/60'
    }`;

  return (
    <div
      className={`inline-flex items-center gap-0.5 rounded-lg border border-stone-200/80 dark:border-slate-600/80 bg-stone-50/90 dark:bg-slate-800/90 p-0.5 ${className}`}
      role="group"
      aria-label={t.language}
    >
      <button
        type="button"
        className={btnClass(current === 'ru-RU')}
        onClick={() => onChange('ru-RU')}
      >
        {compact ? 'RU' : t.russian}
      </button>
      <button
        type="button"
        className={btnClass(current === 'en-US')}
        onClick={() => onChange('en-US')}
      >
        {compact ? 'EN' : t.english}
      </button>
    </div>
  );
};

export default LanguageSwitcher;
